import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Boxes from '../components/BackgroundBoxes';
import '../styles/not-found.css';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found-page">
            <Helmet>
                <title>Page Not Found | TeachGenie™.ai</title>
                <meta
                    name="description"
                    content="The page you are looking for could not be found. Return to the TeachGenie™.ai homepage."
                />
            </Helmet>

            <Boxes />

            <main className="not-found-main">
                <section className="not-found-split" aria-labelledby="not-found-title">
                    <div className="not-found-visual" aria-hidden="true">
                        <img
                            src="/error.png"
                            alt="TeachGenie™ mascot"
                            className="not-found-favicon"
                            loading="eager"
                            decoding="async"
                        />
                    </div>

                    <div className="not-found-copy">
                        <p className="not-found-code">404</p>
                        <h1 id="not-found-title" className="not-found-title">This Page Vanished In Magic</h1>
                        <h2 id="not-found-subtitle" className="not-found-tagline">Knowledge exists everywhere... except here.</h2>
                        <p className="not-found-subtitle">
                            You followed a path that does not exist in this realm. Let&apos;s bring you back.
                        </p>

                        <div className="not-found-actions">
                            <Link to="/" className="not-found-home-btn" aria-label="Back to homepage">
                                <Home size={18} />
                                Homepage
                            </Link>
                            <button
                                type="button"
                                className="not-found-back-btn"
                                onClick={() => navigate(-1)}
                                aria-label="Go to previous page"
                            >
                                <ArrowLeft size={18} />
                                Back
                            </button>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default NotFound;
